import { render, staticRenderFns } from "./Recaudos.vue?vue&type=template&id=0b9ed10e"
import script from "./Recaudos.vue?vue&type=script&lang=js"
export * from "./Recaudos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports